import { resolveImageUrl } from './ImageService';

const PROFILE_COUNT = 10;
const PROFILE_BASE_PATH = '/static/img/profile/profile_';

const hashIdentityKey = (key) => {
    const str = String(key || '');
    if (!str) return 0;

    let sum = 0;
    for (let i = 0; i < str.length; i++) {
        sum = (sum + str.charCodeAt(i)) % PROFILE_COUNT;
    }
    return sum;
};

const toProfilePath = (index) => {
    const num = (index % PROFILE_COUNT) + 1;
    return `${PROFILE_BASE_PATH}${String(num).padStart(2, '0')}.png`;
};

/** userId(또는 익명 닉네임)로 항상 같은 기본 프로필 이미지 경로를 반환 */
export const getDefaultProfileImg = (userId) => {
    return toProfilePath(hashIdentityKey(userId));
};

/** @deprecated naming alias — getDefaultProfileImg와 동일 */
export const getRandomProfile = getDefaultProfileImg;

export const resolveProfileImg = (profileImg, identityKey) => {
    if (profileImg) return resolveImageUrl(profileImg);
    return resolveImageUrl(getDefaultProfileImg(identityKey));
};

export const resolveUserProfileImg = (user) => {
    const profileImg = user?.userProfileImg || user?.user_profile_img;
    const userId = user?.userId || user?.user_id;
    return resolveProfileImg(profileImg, userId);
};

const getPostProfileIdentityKey = (post) => {
    if (post?.post_type === 'PT010') {
        return post.post_writer_nicknm || post.writer || '';
    }
    return post?.post_user_id || post?.user_id || '';
};

export const resolvePostProfileImg = (post) => {
    const profileImg = post?.user_profile_img || post?.writer_profile_img;
    return resolveProfileImg(profileImg, getPostProfileIdentityKey(post));
};

export const resolveCommentProfileImg = (comment, postType) => {
    const profileImg = comment?.writer_profile_img;
    const identityKey = postType === 'PT010'
        ? (comment?.comment_writer_nicknm || '')
        : (comment?.comment_user_id || '');
    return resolveProfileImg(profileImg, identityKey);
};
